// eslint-disable-next-line max-len
var USER_INTERFACE_FAVORITE_STAR = 'M23.69,20.37,25.92,32,16,25.93,6,32,8.3,20.37,0,12l11-1L16,0l5,11,11,1Z';

export { USER_INTERFACE_FAVORITE_STAR };
//# sourceMappingURL=USER_INTERFACE_FAVORITE_STAR.js.map
